// Partner-program attribution.
//
// A partner's code can arrive three ways:
//   1. ?ref=CODE on any page (their link)
//   2. their vanity page /p/:slug (which stores the code)
//   3. typed by hand at signup ("Referred by")
//
// We store it for 60 days so the person can leave, think about it, and come
// back later without the partner losing credit.

const KEY = "sp_partner_ref";
const TTL_DAYS = 60;

export const capturePartnerRef = (code) => {
  if (!code) return;
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ code: String(code).toUpperCase().trim(), at: Date.now() })
    );
  } catch (e) {
    /* private mode — attribution just falls back to the typed field */
  }
};

export const getPartnerRef = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, at } = JSON.parse(raw);
    if (!code) return null;
    if (Date.now() - at > TTL_DAYS * 24 * 60 * 60 * 1000) {
      localStorage.removeItem(KEY);
      return null;
    }
    return code;
  } catch (e) {
    return null;
  }
};

export const clearPartnerRef = () => {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    /* noop */
  }
};

// Call once on app load — picks up ?ref= from any landing URL.
export const captureRefFromUrl = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("ref") || params.get("partner");
    if (code) capturePartnerRef(code);
  } catch (e) {
    /* noop */
  }
};
